{
  "version": 1,
  "asset_id": "7cd520fb-71d6-4858-8396-1e8ec1d636ff",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7cd520fb-71d6-4858-8396-1e8ec1d636ff/sleeve-amateur-1-440.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7cd520fb-71d6-4858-8396-1e8ec1d636ff/sleeve-amateur-1-440.jpg",
  "original_filename": "sleeve-amateur-1-440.jpg",
  "size": 21755,
  "content_type": "image/jpeg",
  "created_at": "2026-09-29T01:15:59Z"
}
